import { Modal, Popover } from 'antd';
import { useState, useEffect } from 'react';
import {
  getAgreementDetail,
  apiGetAreamodule,
  apiGetAgreementPassword,
  apiGetPricingAgreement,
} from 'api/mall';
import styles from './index.module.scss';
import PayQuestionIcon from './PayQuestionIcon';
import { getEnumLabel } from 'libs/utils';
import { tradeModeEnums } from 'libs/enums';
import { cls } from 'reactutils';
import {
  findEnum,
  getCircleNum,
  accountPeriodTypes,
  newAccountPeriodTypes,
  afterPaymentConfigPaymentMode,
  settlementIntervalEnum,
  weekData,
  settlementConfigBillingPeriodList,
  questionMarkMap,
  pricingModelEnum,
} from './helper';
import {
  BaseOnSellPrice,
  BasePrice,
  SteelBarNetPrice,
  InformationPrice,
  CustomPrice,
  MaterialPrice,
  AluminumPrice,
} from './AgreementPriceType';
import ResourceLock from './ResourceLock';
import { cloneDeep } from 'lodash';

const AgreementModal = ({ visible, sysNo, onCancel, isFricing, netPriceType }: any) => {
  const [regionList, setRegionList] = useState([]);
  const [previewObj, setPreviewObj] = useState({
    name: '',
    organizationNameList: '',
    supplierNameList: '',
    projectNameList: '',
    scene: 1,
    config: {
      tradeModeEnum: 1,
      accountPeriodEnumList: [],
      prePaymentConfig: {
        prePaymentRatio: '',
        finalPaymentType: 1,
        installmentList: [],
      },
      afterPaymentConfig: {
        paymentModeEnum: 1,
        installmentList: [],
      },
      settlementConfig: {
        settlementIntervalEnum: 1,
        settlementAfterDays: 0,
        settlementMonthType: '',
        settlementWeekDays: 1,
        settlementMonthDays: 2,
        billingPeriodEnumList: [],
        installmentList: [],
        billingPeriodOtherDays: null,
      },
      pricingModelEnum: 1,
      baseOnSellPrice: {},
      basePriceConfig: {},
      rebarPriceConfig: {
        areaTemplateSysNo: null,
      },
    },
    contractAgreementSysNo: null,
    contractCode: null,
  });
  const [showSourceLock, setShowSourceLock] = useState(false);
  const [passwordInfo, setPasswordInfo] = useState(null);
  useEffect(() => {
    getAgreement();
  }, [sysNo]);
  const loadAreaTemplateDetail = async (previewData) => {
    try {
      if (!previewData.config?.rebarPriceConfig?.areaTemplateSysNo) return;
      const { data } = await apiGetAreamodule(
        previewData.config?.rebarPriceConfig?.areaTemplateSysNo,
      );
      setRegionList(data.regionList || []);
    } catch (err) {}
  };
  const getAgreementPassword = async () => {
    try {
      const { data } = await apiGetAgreementPassword(sysNo);
      setShowSourceLock(true);
      setPasswordInfo({
        ...data,
        sysNo,
      });
    } catch (error) {}
  };
  const getAgreement = async () => {
    try {
      if (!sysNo) return;
      const apiFn = isFricing ? apiGetPricingAgreement : getAgreementDetail;
      const { data } = await apiFn(sysNo);
      setShowSourceLock(false);
      if (!data) return;
      setPreviewObj(data);
      loadAreaTemplateDetail(data);
    } catch (error) {
      if (error.code === 400106) {
        getAgreementPassword();
      }
    }
  };
  const sortPeriod = (collection) => {
    const local = cloneDeep(collection);
    try {
      local.sort((a, b) => {
        return findEnum(accountPeriodTypes, a).seq - findEnum(accountPeriodTypes, b).seq;
      });
    } catch (error) {
      console.log('error', error);
    }
    return local || [];
  };
  return (
    <Modal
      visible={visible}
      title="查看规则"
      footer={null}
      width="1000px"
      style={{ height: '80%' }}
      onCancel={onCancel}
    >
      <div className={styles.full_container}>
        {showSourceLock ? (
          <ResourceLock passwordInfo={passwordInfo} refresh={getAgreement} />
        ) : previewObj?.name ? (
          <div className={styles.main_container}>
            <div className={styles.agreement_title}>
              <span className={styles.ellipsis}> 《 {previewObj.name} 》 </span>
            </div>
            {!!previewObj?.contractAgreementSysNo && (
              <div className={styles.coll_content}>
                <div className={styles.row_item}>
                  <div className={styles.label}>规则编号:</div>
                  <div className={styles.value}>
                    <div className={styles.value_item}>
                      {previewObj.contractAgreementSysNo || null}
                    </div>
                  </div>
                </div>
                <div className={styles.row_item}>
                  <div className={styles.label}>合同编号:</div>
                  <div className={styles.value}>
                    <div className={styles.value_item}>{previewObj.contractCode || null}</div>
                  </div>
                </div>
              </div>
            )}
            <div className={styles.coll_header}>适用范围</div>
            <div className={styles.coll_content}>
              <div className={styles.row_item}>
                <div className={styles.label}>适用组织:</div>
                <div className={styles.value}>
                  {previewObj.organizationNameList?.split(',')?.map((v, i) => (
                    <div className={styles.value_item} key={i}>
                      {v}
                    </div>
                  ))}
                </div>
              </div>

              <div className={styles.row_item}>
                <div className={styles.label}>适用供应商:</div>
                <div className={styles.value}>
                  {previewObj.supplierNameList?.split(',')?.map((v, i) => (
                    <div className={styles.value_item} key={i}>
                      {v}
                    </div>
                  ))}
                </div>
              </div>

              <div className={styles.row_item}>
                <div className={styles.label}>适用项目:</div>
                <div className={styles.value}>
                  {previewObj.projectNameList?.split(',')?.map((v, i) => (
                    <div className={styles.value_item} key={i}>
                      {v}
                    </div>
                  ))}
                </div>
              </div>

              <div className={styles.row_item}>
                <div className={styles.label}>规则类型:</div>
                <div className={styles.value}>
                  <div className={styles.value_item}>
                    {previewObj.scene === 1 ? '代理供货类' : '采购交易类'}
                  </div>
                </div>
              </div>
            </div>

            <div className={styles.coll_header}>交易设置</div>
            <div className={styles.coll_content}>
              <div className={styles.row_item}>
                <div className={styles.label}>交易模式:</div>
                <div className={styles.value}>
                  <div className={styles.value_item}>
                    {getEnumLabel({
                      enums: tradeModeEnums,
                      value: previewObj.config.tradeModeEnum,
                    })}
                    {(previewObj.config.tradeModeEnum === tradeModeEnums.SUPP.value ||
                      previewObj.config.tradeModeEnum === tradeModeEnums.SUBP.value) && (
                      <Popover
                        content={
                          previewObj.config.tradeModeEnum === tradeModeEnums.SUPP.value ? (
                            <div className={styles.mode_tooltip_content}>
                              <p>适用于各种物资品类的交易；</p>
                              <p>提交订单后需进行发货、收货等操作；</p>
                              <p>支持4种交易方式。</p>
                            </div>
                          ) : (
                            <div className={styles.mode_tooltip_content}>
                              <p>适用于专业分包的交易；</p>
                              <p>提交订单后无需进行收货操作，基于订单进行结算；</p>
                              <p>仅支持“结算付款”的交易方式。</p>
                            </div>
                          )
                        }
                        color="#515151"
                        trigger="hover"
                      >
                        <i className={cls('iconfont icon-question1', styles.pay_question_icon)} />
                      </Popover>
                    )}
                  </div>
                </div>
              </div>
              <div className={styles.row_item}>
                <div className={styles.label}>交易方式:</div>
                <div className={styles.value}>
                  {sortPeriod(previewObj.config.accountPeriodEnumList).map((pType, i) => (
                    <div className={styles.value_item} key={i}>
                      {getCircleNum(i + 1)}{' '}
                      {getEnumLabel({
                        enums: newAccountPeriodTypes,
                        value: pType,
                      })}
                      <PayQuestionIcon
                        type={questionMarkMap[pType] || 1}
                        horzontalOffset={i > 1 ? 180 : 50}
                        tradeMode={previewObj.config?.tradeModeEnum}
                      />
                    </div>
                  ))}
                </div>
              </div>
              {previewObj.config?.accountPeriodEnumList?.includes(
                newAccountPeriodTypes.PrePay.value,
              ) && (
                <div className={styles.row_item}>
                  <div className={styles.label}>预付设置:</div>
                  <div className={styles.value}>
                    <div className={styles.value_item}>
                      下单时按订单金额 {previewObj.config?.prePaymentConfig?.prePaymentRatio}%
                      预付，完成交易时按收货金额结清
                    </div>
                  </div>
                </div>
              )}
              {previewObj.config?.accountPeriodEnumList?.includes(
                newAccountPeriodTypes.PrePay.value,
              ) && (
                <div className={styles.row_item}>
                  <div className={styles.label}>尾款结清:</div>
                  <div className={styles.value}>
                    <div
                      className={styles.value_item}
                      style={{
                        flexDirection: 'column',
                      }}
                    >
                      {getEnumLabel({
                        enums: afterPaymentConfigPaymentMode,
                        value: previewObj.config?.prePaymentConfig?.finalPaymentType,
                      })}
                      {previewObj.config?.prePaymentConfig?.finalPaymentType ===
                        afterPaymentConfigPaymentMode.Part.value &&
                        previewObj.config?.prePaymentConfig?.installmentList?.map((item, i) => (
                          <div className={styles.installment_item} key={i}>
                            第 {i + 1} 期付款：订单完成后 T + {item.deferredDays}
                            日(内)，支付交易金额至 {item.ratio}%
                            {item.notFinancialPay && (
                              <span className={styles.installment_item_red}>
                                （该笔为非供应链金融支付，不占用额度）
                              </span>
                            )}
                          </div>
                        ))}
                    </div>
                  </div>
                </div>
              )}
              {previewObj.config?.accountPeriodEnumList?.includes(
                newAccountPeriodTypes.CashOnDelivery.value,
              ) && (
                <div className={styles.row_item}>
                  <div className={styles.label}>货到付款:</div>
                  <div className={styles.value}>
                    <div
                      className={styles.value_item}
                      style={{
                        flexDirection: 'column',
                      }}
                    >
                      {getEnumLabel({
                        enums: afterPaymentConfigPaymentMode,
                        value: previewObj.config?.afterPaymentConfig?.paymentModeEnum,
                      })}
                      {previewObj.config?.afterPaymentConfig?.paymentModeEnum ===
                        afterPaymentConfigPaymentMode.Part.value &&
                        previewObj.config?.afterPaymentConfig?.installmentList?.map((item, i) => (
                          <div className={styles.installment_item} key={i}>
                            第 {i + 1} 期付款：订单完成后 T + {item.deferredDays}
                            日(内)，支付交易金额至 {item.ratio}%
                            {item.notFinancialPay && (
                              <span className={styles.installment_item_red}>
                                （该笔为非供应链金融支付，不占用额度）
                              </span>
                            )}
                          </div>
                        ))}
                    </div>
                  </div>
                </div>
              )}
              {previewObj.config?.accountPeriodEnumList?.includes(
                newAccountPeriodTypes.SettlementPay.value,
              ) && (
                <>
                  <div className={styles.row_item}>
                    <div className={styles.label}>结算周期:</div>
                    <div className={styles.value}>
                      <div className={styles.value_item}>
                        {getEnumLabel({
                          enums: settlementIntervalEnum,
                          value: previewObj.config?.settlementConfig?.settlementIntervalEnum,
                        })}
                        ,<span style={{ padding: '3px' }} />
                        {previewObj.config?.settlementConfig?.settlementIntervalEnum ===
                          settlementIntervalEnum.Day.value && (
                          <span>
                            T日收货后，T +{' '}
                            {previewObj.config?.settlementConfig?.settlementAfterDays}
                            日结算。
                          </span>
                        )}
                        {previewObj.config?.settlementConfig?.settlementIntervalEnum ===
                          settlementIntervalEnum.Week.value && (
                          <span>
                            每周固定结算日为
                            {getEnumLabel({
                              enums: weekData,
                              value: previewObj.config.settlementConfig.settlementWeekDays,
                            })}
                          </span>
                        )}
                        {previewObj.config?.settlementConfig?.settlementIntervalEnum ===
                          settlementIntervalEnum.Month.value && (
                          <span>
                            交易周期为{previewObj.config.settlementConfig.settlementMonthType},
                            每月固定结算日为{previewObj.config.settlementConfig.settlementMonthDays}
                            日
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className={styles.row_item}>
                    <div className={styles.label}>付款账期:</div>
                    <div className={styles.value}>
                      <div
                        className={styles.value_item}
                        style={{
                          flexDirection: 'column',
                        }}
                      >
                        {previewObj.config.settlementConfig?.billingPeriodEnumList?.map(
                          (item, i) => (
                            <div key={i}>
                              {getCircleNum(i + 1)}{' '}
                              {item === settlementConfigBillingPeriodList.OTHER.value
                                ? `${previewObj.config.settlementConfig?.billingPeriodOtherDays}天后一次性付款`
                                : getEnumLabel({
                                    enums: settlementConfigBillingPeriodList,
                                    value: item,
                                  })}
                            </div>
                          ),
                        )}
                      </div>
                      {previewObj.config?.settlementConfig?.billingPeriodEnumList?.includes(
                        settlementConfigBillingPeriodList.PART.value,
                      ) && (
                        <div>
                          {previewObj.config.settlementConfig.installmentList?.map((item, idx) => (
                            <div className={styles.installment_item} key={idx}>
                              第 {idx + 1} 期付款：结算后 T + {item.deferredDays}
                              日(内)，支付结算金额至 {item.ratio}%
                              {item.notFinancialPay && (
                                <span className={styles.installment_item_red}>
                                  （该笔为非供应链金融支付，不占用额度）
                                </span>
                              )}
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                </>
              )}
            </div>

            <div className={styles.coll_header}>价格设置</div>
            <div className={styles.coll_content}>
              <div className={styles.row_item}>
                <div className={styles.label}>定价模板:</div>
                <div className={styles.value}>
                  <div className={styles.value_item}>
                    {getEnumLabel({
                      enums: pricingModelEnum,
                      value: previewObj.config.pricingModelEnum,
                    })}
                  </div>
                </div>
              </div>
              {previewObj.config?.pricingModelEnum === pricingModelEnum.Sales.value && (
                <BaseOnSellPrice previewObj={previewObj} />
              )}
              {previewObj.config?.pricingModelEnum === pricingModelEnum.Agreement.value && (
                <BasePrice previewObj={previewObj} />
              )}
              {previewObj.config?.pricingModelEnum === pricingModelEnum.RebarNet.value && (
                <SteelBarNetPrice
                  previewObj={previewObj}
                  regionList={regionList}
                  netPriceType={netPriceType}
                />
              )}
              {previewObj.config?.pricingModelEnum === pricingModelEnum.Information.value && (
                <InformationPrice previewObj={previewObj}>{null}</InformationPrice>
              )}
              {previewObj.config?.pricingModelEnum === pricingModelEnum.Custom.value && (
                <CustomPrice previewObj={previewObj} />
              )}
              {previewObj.config?.pricingModelEnum === pricingModelEnum.Material.value && (
                <MaterialPrice previewObj={previewObj} />
              )}
              {previewObj.config?.pricingModelEnum === pricingModelEnum.Aluminum.value && (
                <AluminumPrice previewObj={previewObj} />
              )}
            </div>
          </div>
        ) : (
          ''
        )}
        <style jsx>{`
          :global(.ant-popover-inner-content) {
            padding: 10px 20px;
          }
          :global(.ant-table-thead>tr>th) {
            color: #343434;
            font-weight: 400;
          }
          :global(.ant-modal-content) {
            height: 100%;
          }
          :global(.ant-modal-body) {
            height: calc(100% - 55px);
            overflow-y: auto;
          }
        `}</style>
      </div>
    </Modal>
  );
};
export default AgreementModal;
